import {
  POST_CART_TOTALS,
  POST_CATEGORY,
  POST_CUISINE,
  POST_DAYS,
  POST_LANG,
  POST_LANGUAGE_ERROR,
  POST_LANGUAGE_LOADING,
  POST_LOGOUT,
  POST_PREFERRED,
  POST_SELECTED_ADDRESS,
  POST_SELECTED_CHEF,
  POST_SELECTED_WHEN,
  POST_SELECTED_ZIP,
  POST_SESSION_DETAILS,
  POST_SETTING,
  POST_TO_CART,
  POST_TO_CART_GLOCERY,
  POST_USER_DATA,
  TOGGLE_DIALOG
} from "./action";

const myDefaultStore = {
  setting: {},
  selectedWhen: null,
  selectedZip: null,
  selectedAddress: null,
  selectedChef: null,
  selectedCuisine: "all",
  days: [],
  session: null,
  lang: null,
  languageLoading: false,
  languageError: null,
  preferred: [],
  category: [],
  cart: [],
  cart_glocery: [],
  openDialog: false,
  user: null,
  cartTotals: {
    cartTotal: 0,
    tip: 0,
    deliveryFee: 0,
    tax: 0,
    serviceFee: 3.99,
    promoValue: 0,
    total: 0,
    totalWithPromo: 0
  }
};

const reducer = (state = myDefaultStore, action) => {
  if (action.type === POST_SETTING) {
    return {
      ...state,
      setting: action.data
    };
  } else if (action.type === POST_SELECTED_WHEN) {
    return {
      ...state,
      selectedWhen: action.data
    };
  } else if (action.type === POST_SELECTED_ZIP) {
    return {
      ...state,
      selectedZip: action.data
    };
  } else if (action.type === POST_SELECTED_ADDRESS) {
    return {
      ...state,
      selectedAddress: action.data
    };
  } else if (action.type === POST_DAYS) {
    return {
      ...state,
      days: action.data
    };
  } else if (action.type === POST_SESSION_DETAILS) {
    return {
      ...state,
      session: action.data
    };
  } else if (action.type === POST_LANG) {
    return {
      ...state,
      lang: action.data
    };
  } else if (action.type === POST_PREFERRED) {
    return {
      ...state,
      preferred: action.data
    };
  } else if (action.type === POST_CATEGORY) {
    return {
      ...state,
      category: action.data
    };
  } else if (action.type === POST_TO_CART) {
    return {
      ...state,
      cart: action.data
    };
  } else if (action.type === POST_TO_CART_GLOCERY) {
    return {
      ...state,
      cart_glocery: action.data
    };
  } else if (action.type === POST_SELECTED_CHEF) {
    return {
      ...state,
      selectedChef: action.data
    };
  } else if (action.type === POST_USER_DATA) {
    return {
      ...state,
      user: action.data
    };
  } else if (action.type === POST_CUISINE) {
    return {
      ...state,
      selectedCuisine: action.data
    };
  } else if (action.type === TOGGLE_DIALOG) {
    return {
      ...state,
      openDialog: action.data
    };
  } else if (action.type === POST_LANGUAGE_LOADING) {
    return {
      ...state,
      languageLoading: action.data
    };
  } else if (action.type === POST_LANGUAGE_ERROR) {
    return {
      ...state,
      languageError: action.data,
      languageLoading: false
    };
  } else if (action.type === POST_CART_TOTALS) {
    return {
      ...state,
      cartTotals: action.data
    };
  } else if (action.type === POST_LOGOUT) {
    return {
      ...state,
      setting: {},
      selectedWhen: null,
      selectedZip: null,
      selectedAddress: null,
      selectedChef: null,
      selectedCuisine: "all",
      days: [],
      session: null,
      lang: null,
      languageLoading: false,
      languageError: null,
      preferred: [],
      category: [],
      cart: [],
      cart_glocery: [],
      openDialog: false,
      user: null
    };
  }
  return state;
};

export default reducer;
